import HttpFactory from '@/mixins/http.factory';
import download from "downloadjs";
import customAgGrid from '@/components/custom-ag-grid/custom-ag-grid.vue';
import dateTimeRenderer from '@/components/custom-ag-grid/dateTimeRenderer/dateTimeRenderer.vue';

export default {
	name:'linked-tickets',
	mixins:[HttpFactory],
	data () {
		return {
			filters:{searchText:null},
			data:null,
			linkedTickets:[],
			gridOptionsApi:null
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo = data;
					_self.getData();
				}
			});
		},
		getData(){
			let _self=this;
			_self.fn().clearMessage();
			let data={auth:_self.zendeskInfo.credentials};

			var url=`linkedtickets/all`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				_self.linkedTickets=response.data.Data;
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		onGridOptionsApi(params){
            this.gridOptionsApi=params;
        },
        async filterData(){
            const _self=this;
            const searchText=_self.filters.searchText;
            _self.gridOptionsApi.api.setQuickFilter(searchText);
        },
		exportData(){
			let _self=this;
			let linkedTickets=_self.linkedTickets;
			_self.fn().sortNumCol(linkedTickets,'hdTicketId',true);
			let defaultNullVal='-';
			let fileName = `linked_tickets.csv`;
			let csvData = `Ticket #, Subject, Issue #, Labels, Repository, Title, Status, Assignee, Description \r\n`;
			linkedTickets.forEach(function (item) {
				let row = `${_self.fn().formatCSV(item.hdTicketId?item.hdTicketId:defaultNullVal)},${_self.fn().formatCSV(item.hdSubject?item.hdSubject:defaultNullVal)},${_self.fn().formatCSV(item.issueId?item.issueId:defaultNullVal)},${_self.fn().formatCSV(item.tags?item.tags.toString():defaultNullVal)},${_self.fn().formatCSV(item.repository?item.repository:defaultNullVal)},${_self.fn().formatCSV(item.githubTitle?item.githubTitle:defaultNullVal)},${_self.fn().formatCSV(item.status?item.status:defaultNullVal)},${_self.fn().formatCSV(item.assignedTo?item.assignedTo:defaultNullVal)},${_self.fn().formatCSV(item.description?item.description:defaultNullVal)}`;
				csvData += row + "\r\n";
			});
			download(csvData, fileName, 'data:application/csv;charset=utf-8');
		},
	},
	components:{
		customAgGrid
	},
	beforeMount() {
		let _self  =this;
		let commonWidth=125;//=120;
		_self.columnDefs = [
		  { headerName: 'Ticket #', field: 'hdTicketUrl', width: commonWidth,cellClass:'text-left',
		 	 cellRenderer:function(params){
				return `<a href="${params.value}" target="_blank">${params.data.hdTicketId}</a>`;
			}
		},
		  { headerName: 'Subject', field: 'hdSubject',width: commonWidth },
		  { headerName: 'Issue #', field: 'issueUrl', width:100,
			cellRenderer:function(params){
				return `<a href="${params.value}" target="_blank">${params.data.issueId}</a>`;
			}	
		  },
		  { headerName: 'Labels', field: 'tags',width: commonWidth },
		  { headerName: 'Repository', field: 'repository',width: commonWidth },
		  { headerName: 'Title', field: 'githubTitle',width: commonWidth },
		  { headerName: 'Status', field: 'status',width: commonWidth },
		  { headerName: 'Assignee', field: 'assignedTo',width: commonWidth },
		  //{ headerName: 'Description', field: 'description',width: commonWidth },
		];
	}
}

